export default {
  plans: "upgrade/plans",
  upgrades: "upgrade",
  submit: "upgrade/submit",
  checklist: (category) => `upgrade/checklist/${category}`,
  upgradeReport: "upgrade/upgrade-report",
  upgradeAcceptanceLetter: "upgrade/acceptance-letter",
};
